// extracted by mini-css-extract-plugin
export default {"wrapper":"Tk7ML","link":"YqTpY"};